module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooseschool chooseschool1"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "search-box",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    class: ['current-city', {
      'on': _vm.showCity
    }],
    on: {
      "click": _vm.toggleCity
    }
  }, [_vm._v(_vm._s(_vm.currentCity.city_name))]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipinput),
      expression: "tipinput"
    }],
    attrs: {
      "id": "tipinput",
      "placeholder": "搜索当前城市下的具体地址"
    },
    domProps: {
      "value": (_vm.tipinput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tipinput = $event.target.value
      }, function($event) {
        return _vm.getSuggestions()
      }]
    }
  }), _vm._v(" "), (_vm.suggestionList.length) ? _c('ul', _vm._l((_vm.suggestionList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.setCitySearch(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.tipinput != '') ? _c('span', {
    staticClass: "clearbtn",
    on: {
      "click": _vm.clearInput
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCity),
      expression: "showCity"
    }],
    staticClass: "choose-city"
  }, [_c('div', {
    staticClass: "city-list"
  }, [_c('div', {
    attrs: {
      "id": "cityList"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('div', {
      staticClass: "city-box"
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "id": item.pinyin_index
      }
    }, [_vm._v(_vm._s(item.pinyin_index))]), _vm._v(" "), _c('ul', _vm._l((item.city_list), function(item2) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.chooseCity(item2.city_name, item2.city_id)
          }
        }
      }, [_vm._v(_vm._s(item2.city_name))])
    }), 0)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pinyin"
  }, _vm._l((_vm.pinyinList), function(item) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.choosePinyin(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCity),
      expression: "!showCity"
    }]
  }, [_c('div', {
    staticStyle: {
      "height": "5rem",
      "margin-top": "0.88rem"
    },
    attrs: {
      "id": "mapContainer"
    }
  }), _vm._v(" "), (_vm.poiList.length) ? _c('div', {
    staticClass: "search-result",
    staticStyle: {
      "padding": "0 0.26rem"
    }
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.poiList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.saveInfo(item)
        }
      }
    }, [_c('a', [_c('p', {
      class: {
        'first': index == 0
      }
    }, [(index == 0) ? _c('span', [_vm._v("[当前位置]")]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "detail"
    }, [_vm._v(_vm._s(item.address))])])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8b74a622","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/ChooseAddress.vue
// module id = 455
// module chunks = 7